/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceList_brand$ref: FragmentReference;
declare export opaque type InvoiceList_brand$fragmentType: InvoiceList_brand$ref;
export type InvoiceList_brand = {|
  +id: string,
  +name: string,
  +$refType: InvoiceList_brand$ref,
|};
export type InvoiceList_brand$data = InvoiceList_brand;
export type InvoiceList_brand$key = {
  +$data?: InvoiceList_brand$data,
  +$fragmentRefs: InvoiceList_brand$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceList_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Store"
};
// prettier-ignore
(node/*: any*/).hash = '7b0150225be027e23ad1c64bb3c42917';

module.exports = node;
